module.exports = __webpack_public_path__ + "img/stickers_0000_heart.8d53b185.png";